export function scrollToPanel(ref) {
  setTimeout(() => {
    ref.current.scrollIntoView({
      block: 'start',
      behavior: 'smooth',
    });
  }, 200);
}
